import { createAsyncThunk } from '@reduxjs/toolkit';
import { CURR_USER_BOOTSTRAP } from './constants';

const getCurrUser = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/me');
  } catch (e) {}
};

const getCurrUserPermission = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/me/permission');
  } catch (e) {}
};

const getSettingsDetails = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/settings');
  } catch (e) {}
};

const onFetchCurrUser = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/me');
  } catch (e) {}
};

const getExtensionInstallStatus = async () => {
  return true;
};

const onFetchImport = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/user_import_statuses/recent_pending_import');
  } catch (e) {}
};

const onFetchImportById = async ({ importId }, { extra: { http } }) => {
  try {
    return await http.get(`/user_import_statuses/${importId}`);
  } catch (e) {}
};

export const bootstrapCurrentUserPermissions = createAsyncThunk(
  CURR_USER_BOOTSTRAP,
  getCurrUser
);

export const bootstrapCurrentUser = createAsyncThunk(
  CURR_USER_BOOTSTRAP,
  getCurrUser
);

export const bootstrapCurrentPermission = createAsyncThunk(
  'user/permission',
  getCurrUserPermission
);

export const bootstrapSettingsDetails = createAsyncThunk(
  'user/settings',
  getSettingsDetails
);

export const fetchCurrentUser = createAsyncThunk(
  'current/user/fetch',
  onFetchCurrUser
);

export const bootstrapExtensionCheck = createAsyncThunk(
  'user/extension',
  getExtensionInstallStatus
);

export const fetchPendingImport = createAsyncThunk(
  'current/import/fetch',
  onFetchImport
);

export const fetchImportById = createAsyncThunk(
  'current/import/fetch/id',
  onFetchImportById
);
